module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/voice-logo-hands-ecde0125261f422ecb8be9966ef6fb8c.png";